// Seed data derived from the 4 sample debt slips provided by the client.
// Used by ra-data-local-forage the first time the app runs (empty IndexedDB).
import type { Supplier, VatInvoice } from './types';

const suppliers: Supplier[] = [
  {
    id: 1,
    name: 'CÔNG TY TNHH MTV HOA VIỆT LS',
    taxCode: '4900932884',
    bankName: 'VietinBank',
    bankBin: '970415',
    accountNumber: '11002626204',
    accountHolder: 'CTY TNHH MTV HOA VIET LS',
    phone: '0816225686',
    address: 'Thị trấn Cao Lộc, Huyện Cao Lộc, Lạng Sơn',
  },
  {
    id: 2,
    name: 'CÔNG TY TNHH MTV TM PHÚ AN HUY',
    taxCode: '',
    bankName: 'VietinBank',
    bankBin: '970415',
    accountNumber: '107868644477',
    accountHolder: 'NGUYEN HUU HUY',
    phone: '0982184888',
    address: 'Tổ 4, Khối 8, P. Đông Kinh, TP Lạng Sơn',
    note: 'STK nhận là cá nhân (Nguyễn Hữu Huy), khác tên công ty.',
  },
  {
    id: 3,
    name: 'CÔNG TY CP TM HOÀNG NGUYÊN LẠNG SƠN',
    taxCode: '',
    bankName: 'Vietcombank',
    bankBin: '970436',
    accountNumber: '0123456789',
    accountHolder: 'CTY CP TM HOANG NGUYEN LANG SON',
    phone: '02053712158',
    address: 'Số 48, Tổ 1, Khối 10, Đường Mỹ Sơn, P. Kỳ Lừa, Lạng Sơn',
    note: 'STK là dữ liệu mẫu — thay bằng STK thật.',
  },
  {
    id: 4,
    name: 'NPP VŨ TUẤN ANH (PHƯƠNG TOÀN)',
    taxCode: '',
    bankName: 'BIDV',
    bankBin: '970418',
    accountNumber: '0987654321',
    accountHolder: 'VU TUAN ANH',
    phone: '02053875542',
    address: 'KM15+500 Tổ 5, Khối 3, TT Cao Lộc, H. Cao Lộc, Lạng Sơn',
    note: 'STK là dữ liệu mẫu — thay bằng STK thật.',
  },
];

const vatInvoices: VatInvoice[] = [
  {
    id: 1,
    invoiceNumber: 'HD-HV-731942',
    supplierName: 'CÔNG TY TNHH MTV HOA VIỆT LS',
    taxCode: '4900932884',
    invoiceDate: '2026-06-12',
    amount: 810179,
    note: 'Khớp phiếu xuất kho Hoa Việt (DÂY XMEN WOOD).',
  },
  {
    id: 2,
    invoiceNumber: 'HD169135.01',
    supplierName: 'CÔNG TY TNHH MTV TM PHÚ AN HUY',
    invoiceDate: '2026-07-24',
    amount: 24325000,
    note: 'Khớp hóa đơn bán hàng Phú An Huy (Đường trắng).',
  },
  {
    id: 3,
    invoiceNumber: 'DV058T01226723010UV',
    supplierName: 'CÔNG TY CP TM HOÀNG NGUYÊN LẠNG SƠN',
    invoiceDate: '2026-07-23',
    amount: 24890000,
    note: 'Khớp phiếu giao nhận Hoàng Nguyên (Bột mì, Dầu thực vật).',
  },
  {
    id: 4,
    invoiceNumber: '0000019992',
    supplierName: 'NPP VŨ TUẤN ANH (PHƯƠNG TOÀN)',
    invoiceDate: '2026-07-23',
    amount: 4600000,
    note: 'CHỈ đơn lần này 4.600.000 (KHÔNG gồm nợ cũ 16.906.261). Minh họa bẫy "Tổng cộng 21.506.261".',
  },
  {
    id: 5,
    invoiceNumber: 'HD-TT-0996',
    supplierName: 'CÔNG TY TNHH TM THANH TRUNG LS',
    invoiceDate: '2026-07-20',
    amount: 5000000,
    note: 'Hóa đơn nhiễu (không có phiếu tương ứng) để test đối soát.',
  },
];

export const seedData = {
  // MISA is the source of truth. Keep a fresh installation empty until the
  // user explicitly starts a sync or imports an Excel file.
  suppliers: [],
  vatInvoices: [],
  debtSlips: [],
  paymentOrders: [],
};
